import { fetchApi, fetchWithoutToken } from '../util/fetch-api';

const REFERRAL_CODES_PATH = '/ecom/api/v1/referral_codes';
const REFERRER_ME_PATH = '/ecom/api/v1/referrers/me';

const toErrorStatus = (error) => error?.response?.status || 500;
const toErrorMessage = (error) => error?.message || 'unknown_error';

const buildCreatePayload = (referrer = {}) => ({
  referrer: Object.fromEntries(
    Object.entries({
      name: referrer.name,
      payout_preference: referrer.payoutPreference,
      payout_details: referrer.payoutDetails,
    }).filter(([, value]) => value != null)
  ),
});

export async function fetchPublicReferralByCode(code) {
  const response = await fetchWithoutToken(
    `${REFERRAL_CODES_PATH}/${encodeURIComponent(code)}`
  );

  if (response.status === 404) {
    return { data: null, status: 404 };
  }

  if (!response.ok) {
    return {
      data: null,
      status: response.status,
      error: response.statusText || 'Service Error',
    };
  }

  const json = await response.json();
  return { data: json.referrer, status: response.status };
}

async function performReferrerRequest(path, options = {}) {
  try {
    const json = await fetchApi(path, options);

    return {
      data: json?.referrer || null,
      status: options.method === 'POST' ? 201 : 200,
    };
  } catch (error) {
    return {
      data: null,
      status: toErrorStatus(error),
      error: toErrorMessage(error),
    };
  }
}

export function fetchMyReferrerProfile() {
  return performReferrerRequest(REFERRER_ME_PATH);
}

export function createMyReferrerProfile(referrer = {}) {
  return performReferrerRequest(REFERRER_ME_PATH, {
    method: 'POST',
    body: JSON.stringify(buildCreatePayload(referrer)),
    headers: {
      'Content-Type': 'application/json',
    },
  });
}

export async function resolveMyReferrerProfile(referrer = {}) {
  const existing = await fetchMyReferrerProfile();
  if (existing.status === 200) {
    return existing;
  }

  if (existing.status !== 404) {
    return existing;
  }

  const created = await createMyReferrerProfile(referrer);
  if ([200, 201].includes(created.status)) {
    return created;
  }

  if (created.status === 422) {
    return fetchMyReferrerProfile();
  }

  return created;
}
